/* CEP-BUILD 2026-09-25-Z | if this line is missing or older, you are pasting a stale file */
class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.predictiveSearchForm = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search-results');

        this.searchDropdownContainer = this.querySelector('.search-dropdown-container');
        this.recommendationProducts = this.querySelector('.search-dropdown-recommendations');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        this.input.addEventListener('search', () => this.onChange());
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }
        let searchTerms = {};

        const formElements = Array.from(this.predictiveSearchForm);

        formElements.forEach(element => {
            if (element.name.length) {
                searchTerms[element.name] = element.value;
            }
        });

        const stringifySearchTerms = JSON.stringify(searchTerms);
        const paramsSearchTerms = stringifySearchTerms.slice(1, -1).replace(/","/g, '"&"').replace(/:/g, '=').replace(/"/g, '');

        this.requestId = (this.requestId || 0) + 1;
        this.total = null;

        this.getSearchResults(paramsSearchTerms, this.requestId);
        this.getResultsTotal(searchTerm, this.requestId);
    }

    /* Asks templates/search.count.liquid for the real catalog total.

       EVERY options[...] FIELD ON THE FORM IS FORWARDED, not just the prefix.
       Measured on /search?q=socks: products only returns 182 with the sold-out
       products hidden and 189 with `options[unavailable_products]=last`, which
       is the theme's default and what the form actually submits. Sending only
       the prefix would have made the dropdown say 182 next to a results page
       reading 189 -- the same class of bug as the original count, arrived at a
       different way. Reading the fields off the form means the count follows the
       setting wherever it is changed, with nothing to keep in sync here.

       `type` is pinned to product rather than read from the form: the form's own
       type can carry collection, page and article for the dropdown, and this
       number belongs to the product grid. (A bare /search?q=socks with no type
       at all counts pages and articles too, which is where 184 comes from.) */
    getResultsTotal(searchTerm, requestId) {
        const params = new URLSearchParams();
        params.set('view', 'count');
        params.set('type', 'product');
        params.set('q', searchTerm);

        this.predictiveSearchForm.querySelectorAll('[name^="options["]').forEach((field) => {
            if (field.value) params.set(field.name, field.value);
        });

        const url = `${window.Shopify.routes.root}search?${params.toString()}`;

        fetch(url)
            .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
            .then((text) => {
                if (requestId !== this.requestId) return;

                /* A missing search.count.liquid makes Shopify serve the whole
                   search page instead, and stripping non-digits out of that
                   would produce a confident wrong number. A real response is a
                   few bytes, so anything longer is treated as no answer. */
                const raw = text.trim();
                if (!raw.length || raw.length > 12) return;

                const total = parseInt(raw.replace(/[^0-9]/g, ''), 10);
                if (isNaN(total)) return;

                this.total = total;
                this.renderTotal();
            })
            .catch(() => {
                /* Silent on purpose: the count is an enhancement, and the cards
                   are already on screen. No count beats an error state here. */
            });
    }

    renderTotal() {
        if (this.total === null || this.total === undefined) return;

        const link = this.predictiveSearchResults.querySelector('#cep-search-products .cep-search-viewall');
        if (!link) return;

        let counter = link.querySelector('.cep-search-count');
        if (!counter) {
            counter = document.createElement('span');
            counter.className = 'cep-search-count';
            link.appendChild(counter);
        }
        counter.textContent = ` (${this.total})`;
    }

    getSearchResults(searchTerms, requestId) {
        // console.log("search terms", searchTerms, window.Shopify.routes);

        // fetch(window.Shopify.routes.root + 'search/suggest?' + searchTerms)
        fetch(`${window.Shopify.routes.root}search/suggest?${searchTerms}&section_id=predictive-search`)
            .then((response) => {
                // console.log("res", response)

                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((res) => {
                // console.log("res", res);
                const resultsMarkup = new DOMParser().parseFromString(res, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

                if (requestId !== undefined && requestId !== this.requestId) return;

                this.predictiveSearchResults.innerHTML = resultsMarkup;

                /* The count may already be back; if it is not, its own handler
                   calls this again once it lands. */
                this.renderTotal();

                const resultsLazyloadImages = this.predictiveSearchResults.querySelectorAll('.lazy-loading-image');

                resultsLazyloadImages.forEach(imageContainer => {
                    lazyloading(imageContainer);
                })

                // this.appendChild(resultsMarkup)
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.searchDropdownContainer.classList.add('has-predictive-search-results');
        // this.predictiveSearchResults.style.display = 'block';

        if(this.recommendationProducts){
            this.recommendationProducts.classList.add('inactive');
        }
    }

    close() {
        this.searchDropdownContainer.classList.remove('has-predictive-search-results');
        // this.predictiveSearchResults.style.display = 'none';

        if(this.recommendationProducts){
            this.recommendationProducts.classList.remove('inactive');
        }
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
